/**
 * @desc 导入手工单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/import`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
